import { useQuery } from '@tanstack/react-query';

export const useQueryData = (queryKey: any, queryFn: any, options: any = {}) => {
  return useQuery({ queryKey, queryFn, ...options });
};
